import React, { useEffect, useState } from 'react';
import {
  getQuotes,
  getQuoteDetails,
} from '../services/api/domains/salesforce/service';
import { Quote, QuoteDetails } from '../services/api/domains/salesforce';

const QuotesReview: React.FC = () => {
  const [quotes, setQuotes] = useState<Quote[]>([]);
  const [selectedQuote, setSelectedQuote] = useState<Quote | null>(null);
  const [details, setDetails] = useState<QuoteDetails | null>(null);

  useEffect(() => {
    getQuotes().then(setQuotes);
  }, []);

  async function handleSelect(quote: Quote) {
    setSelectedQuote(quote);
    const data = await getQuoteDetails(quote.Id);
    setDetails(data);
  }

  return (
    <div style={styles.containerStyle}>
      <h1 style={styles.titleStyle}>Salesforce RFQs</h1>
      <table style={styles.tableStyle}>
        <thead>
          <tr style={styles.tableHeaderRowStyle}>
            <th style={styles.tableHeaderStyle}>Quote</th>
            <th style={styles.tableHeaderStyle}>Status</th>
            <th style={styles.tableHeaderStyle}>Total</th>
          </tr>
        </thead>
        <tbody>
          {quotes.map(q => (
            <tr
              key={q.Id}
              onClick={() => handleSelect(q)}
              style={styles.tableRowStyle}>
              <td style={styles.tableCellStyle}>{q.Name}</td>
              <td style={styles.tableCellStyle}>{q.Status}</td>
              <td style={styles.tableCellStyle}>${q.GrandTotal}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedQuote && details && (
        <div style={styles.detailsContainerStyle}>
          <h2 style={styles.detailsTitleStyle}>
            RFQ Details: {selectedQuote.Name}
          </h2>

          <h3 style={styles.sectionTitleStyle}>Products Requested</h3>
          <ul>
            {details.lineItems.map((li, idx) => (
              <li key={idx}>
                {li.Product2?.Name} (Code {li.Product2?.ProductCode}) – Qty{' '}
                {li.Quantity} @ ${li.UnitPrice}
              </li>
            ))}
          </ul>

          <h3 style={styles.sectionTitleMarginStyle}>Manufacturer Products</h3>
          <ul>
            {details.manufacturerProducts.map((mp, idx) => (
              <li key={idx}>
                {mp.product_name} (Grade: {mp.grade})
              </li>
            ))}
          </ul>

          <h3 style={styles.sectionTitleMarginStyle}>FDA NDC Data</h3>
          <pre style={styles.preStyle}>
            {JSON.stringify(details.ndcData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  containerStyle: {
    padding: '1.5rem', // p-6
  } as React.CSSProperties,
  titleStyle: {
    fontSize: '1.25rem', // text-xl
    fontWeight: 'bold',
    marginBottom: '1rem', // mb-4
  } as React.CSSProperties,
  tableStyle: {
    tableLayout: 'auto',
    width: '100%',
    border: '1px solid #e5e7eb',
  } as React.CSSProperties,
  tableHeaderRowStyle: {
    backgroundColor: '#f3f4f6', // bg-gray-100
  } as React.CSSProperties,
  tableHeaderStyle: {
    border: '1px solid #e5e7eb',
    padding: '0.5rem', // p-2
  } as React.CSSProperties,
  tableRowStyle: {
    cursor: 'pointer',
  } as React.CSSProperties,
  tableCellStyle: {
    border: '1px solid #e5e7eb',
    padding: '0.5rem', // p-2
  } as React.CSSProperties,
  detailsContainerStyle: {
    marginTop: '1.5rem', // mt-6
    border: '1px solid #e5e7eb',
    borderRadius: '0.25rem', // rounded
    padding: '1rem', // p-4
    backgroundColor: 'white',
    boxShadow:
      '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)', // shadow
  } as React.CSSProperties,
  detailsTitleStyle: {
    fontSize: '1.125rem', // text-lg
    fontWeight: '600', // font-semibold
    marginBottom: '0.5rem', // mb-2
  } as React.CSSProperties,
  sectionTitleStyle: {
    fontWeight: '500', // font-medium
  } as React.CSSProperties,
  sectionTitleMarginStyle: {
    fontWeight: '500', // font-medium
    marginTop: '1rem', // mt-4
  } as React.CSSProperties,
  preStyle: {
    backgroundColor: '#f3f4f6', // bg-gray-100
    padding: '0.5rem', // p-2
    borderRadius: '0.25rem', // rounded
  } as React.CSSProperties,
};

export default QuotesReview;
